import { colors } from "@/styles/colors"
import { makeStyles } from "@material-ui/core"

const useStyles = makeStyles({
	questionLabel: {
		marginBottom: 10,
		fontSize: 14,
		fontWeight: 500,
		color: colors.gray[800]
	}
})

export default useStyles
